import angular from 'angular'

import generalCtrl from './general.controller'
import generalRoutes from './general.routes'
import generalRun from './general.run'

const name = 'routingSettingGeneral'

angular.module(name, [])
  .controller('generalCtrl', generalCtrl)
  .config(generalRoutes)
  .run(generalRun)

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/setting/general/general.module.js